export default "__VITE_ASSET__BirdLaF0__"